export { ColorsClasses } from './colors'
export type { Colors, Tones } from './colors'

export { WeightsClasses } from './weights'
export type { Weights } from './weights'

const Collator = new Intl.Collator(undefined, { sensitivity: 'base' });

export { Collator };